export default {
  saved: "Los datos se guardaron correctamente",
  updated: "Los datos se actualizaron correctamente",
  deleted: "Los datos se eliminaron correctamente",
  sent: "La solicitud se envió correctamente",
  error: "Error del sistema - Por favor contacte al administrador",
  assetReviewed: "El activo fue revisado correctamente",
  assetCreated: "El Activo ha sido creado correctamente y está siendo verificado por el operador de la plataforma.",
  assetEdited: "El Activo ha sido editado correctamente.",
  assetTypeCreated: "El Tipo de Activo ha sido creado correctamente.",
  assetModelCreated: "El Modelo de Activo ha sido creado correctamente.",
  assetTypeEdited: "El Tipo de Activo ha sido editado correctamente.",
  assetModelEdited: "El Modelo de Activo ha sido editado correctamente.",
  safetyNoteCreated: "La Nota de Seguridad ha sido creada correctamente.",
  safetyNoteEdited: "La Nota de Seguridad ha sido editada correctamente.",
  errorCodeLetters: "El Identificador debe tener el formato XX-XXXXXXXXXXXXXX (letra(s) número).",
  manufacturerCode: "Por favor ingrese un código de fabricante.",
  manufacturerName: "Por favor ingrese un nombre de fabricante.",
  selectTenant: "Por favor seleccione un operador",
  selectAssetType: "Por favor seleccione un tipo de activo",
  selectAssetModel: "Por favor seleccione un modelo de activo",
  selectUnit: "Por favor seleccione una unidad",
  enterName: "Por favor ingrese un nombre",
  selectType: "Por favor seleccione un dato de entrada",
  selectProject: "Por favor seleccione un proyecto",
  selectBillingAddress: "Por favor seleccione una dirección de facturación",
  selectContact: "Por favor seleccione al menos un contacto",
  exportSuccessful: "La exportación se preparará en segundo plano y se le enviará por correo electrónico.",
  exportNotSuccessful: "Desafortunadamente hubo un error con la solicitud. Por favor intente de nuevo más tarde.",
  locationSaveFailed: "Los datos de ubicación no se pudieron guardar. Por favor, inténtelo de nuevo.",
};
